// extracted by mini-css-extract-plugin
export default {"downloadContainer":"ClientDetails_downloadContainer__ozCVH","download":"ClientDetails_download__aFygt","modalWrapper":"ClientDetails_modalWrapper__g6GUO"};